import { ContactOptions } from '@propertypal/shared/src/types/contact';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import React, { useState } from 'react';
import { Text } from '../typography';
import { MaxWidth } from './ContactForm.style.pn';
import ContactFormWrapper from './ContactFormWrapper';

interface Props {
  options: ContactOptions;
}

const ContactForm: React.FC<Props> = (props) => {
  const [sent, setSent] = useState<boolean>(false);

  return (
    <PageWrapper overflow="initial">
      <MaxWidth>
        <ContactFormWrapper {...props} sent={sent} setSent={setSent} maxWidth={400} mw={1080} flexDirection="column" />

        <Text fontSize={17} color="#757575" mt={85}>
          Unit 2D, Jennymount Business Park, North Derby Street, Belfast, Co. Antrim, BT15 3HN, N. Ireland
        </Text>
        <Text fontSize={17} color="#757575">
          Opening hours: Monday - Friday: 9am - 5pm
        </Text>
      </MaxWidth>
    </PageWrapper>
  );
};

export default ContactForm;
